<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title class="font-weight-bold justify-center">Catálogo de convocatorias</v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row justify="end" align="center" class="mx-n2">
                <v-col cols="12" md="3" class="px-2">
                  <TextButton rounded color="secondary" @click="openRegistrarConvocatoriaDialog">
                    Registrar convocatoria
                  </TextButton>
                </v-col>
                <v-col cols="12" md="3" class="pl-1">
                  <v-text-field
                    v-model="buscaConvocatoria"
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="primary"
                    color="secondary"
                    label="Buscar convocatoria"
                    append-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <IconButton variant="secondary" icon="mdi-download" @click="downloadConvocatoriasCsv" />
                      </span>
                    </template>
                    <span>Descargar CSV</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    class="primary"
                    :headers="headers"
                    :items="convocatorias"
                    :search="buscaConvocatoria"
                    :loading="loading"
                    loading-text="Cargando convocatorias..."
                    dense
                    calculate-widths
                    show-expand
                    :expanded.sync="expanded"
                  >
                    <!-- Columnas principales visibles -->
                    <template v-slot:[`item.fechaHoraPublicacionConvocatoria`]="{ item }">
                      {{ formatDate(item.fechaHoraPublicacionConvocatoria) }}
                    </template>
                    <template v-slot:[`item.fechaHoraInicioRegistro`]="{ item }">
                      {{ formatDate(item.fechaHoraInicioRegistro) }}
                    </template>
                    <template v-slot:[`item.fechaHoraCierreRegistro`]="{ item }">
                      {{ formatDate(item.fechaHoraCierreRegistro) }}
                    </template>
                    <template v-slot:[`item.fechaHoraResultados`]="{ item }">
                      {{ formatDate(item.fechaHoraResultados) }}
                    </template>

                    <!-- Panel expandido con detalles adicionales -->
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pa-4">
                        <v-card flat color="secondary lighten-4">
                          <v-card-text>
                            <v-row dense>
                              <v-col cols="12" md="6">
                                <div class="text-subtitle-2 font-weight-bold">Beneficios</div>
                                <div class="text-body-2">{{ item.beneficios || '-' }}</div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div class="text-subtitle-2 font-weight-bold">Requisitos</div>
                                <div class="text-body-2">{{ item.requisitos || '-' }}</div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div class="text-subtitle-2 font-weight-bold">Documentación</div>
                                <div class="text-body-2">{{ item.documentacion || '-' }}</div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div class="text-subtitle-2 font-weight-bold">Lugar de recepción</div>
                                <div class="text-body-2">{{ item.lugarRecepcionDocumentos || '-' }}</div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div class="text-subtitle-2 font-weight-bold">Fecha de recepción</div>
                                <div class="text-body-2">{{ formatDate(item.fechaHoraRecepcionDocumentos) }}</div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div class="text-subtitle-2 font-weight-bold">Procedimiento de selección</div>
                                <div class="text-body-2">{{ item.procedimientoSeleccion || '-' }}</div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div class="text-subtitle-2 font-weight-bold">Dirigido a</div>
                                <div class="text-body-2">{{ item.catDirigido?.title || '-' }}</div>
                              </v-col>
                              <v-col cols="12" md="6">
                                <div class="text-subtitle-2 font-weight-bold">Grado a promocionar</div>
                                <div class="text-body-2">{{ item.catGradoPromocion?.title || '-' }}</div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </td>
                    </template>

                    <!-- Columna de opciones -->
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                class="mr-2"
                                variant="secondary"
                                icon="mdi-pencil"
                                @click="openEditarConvocatoriaDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Editar convocatoria</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                elevation="8"
                                class="mr-2"
                                variant="secondary"
                                icon="mdi-account-multiple"
                                @click="openPersonalVinculadoDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Ver personal vinculado</span>
                        </v-tooltip>
                        <!-- <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                elevation="8"
                                variant="secondary"
                                icon="mdi-account-multiple-plus"
                                @click="openAsignarPersonalDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Asignar personal manualmente</span>
                        </v-tooltip> -->
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import TextButton from '../../components/base/TextButton.vue'
import IconButton from '@/components/base/IconButton.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import moment from 'moment'
import downloadCsv from '@/utils/downloadCsv'

export default {
  components: {
    TextButton,
    IconButton,
  },

  data() {
    return {
      buscaConvocatoria: '',
      loading: false,
      expanded: [],
      // Solo las 8 columnas más importantes + opciones
      headers: [
        { text: 'Convocatoria', value: 'convocatoria', align: 'left' },
        { text: 'Plazas', value: 'plazasVacantes', align: 'center' },
        { text: 'Fecha Publicación', value: 'fechaHoraPublicacionConvocatoria', align: 'left' },
        { text: 'Fecha Inicio', value: 'fechaHoraInicioRegistro', align: 'left' },
        { text: 'Fecha Cierre', value: 'fechaHoraCierreRegistro', align: 'left' },
        { text: 'Fecha Resultados', value: 'fechaHoraResultados', align: 'left' },
        { text: 'SubTipo', value: 'catSubTipoConvocatoria.title', align: 'left' },
        { text: 'Tipo', value: 'catSubTipoConvocatoria.catTipoConvocatoria.title', align: 'left' },
        { text: 'Opciones', value: 'opciones', sortable: false, align: 'center' },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },

  computed: {
    ...mapGetters('convocatorias', {
      convocatorias: 'getConvocatorias',
    }),
    filteredConvocatorias() {
      const term = (this.buscaConvocatoria || '').trim().toLowerCase()
      if (!term) return this.convocatorias || []
      return (this.convocatorias || []).filter(
        (c) =>
          (c.convocatoria || '').toLowerCase().includes(term) ||
          (c.catSubTipoConvocatoria?.title || '').toLowerCase().includes(term) ||
          (c.catSubTipoConvocatoria?.catTipoConvocatoria?.title || '').toLowerCase().includes(term)
      )
    },
  },

  async mounted() {
    await this.loadConvocatorias()
  },

  methods: {
    ...mapActions('convocatorias', ['fetchAllConvocatorias']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    async loadConvocatorias() {
      try {
        this.loading = true
        await this.fetchAllConvocatorias()
      } catch (error) {
        console.error('Error al cargar las convocatorias:', error)
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al cargar las convocatorias')
      } finally {
        this.loading = false
      }
    },

    formatDate(date) {
      if (!date) return '-'

      if (typeof date === 'string' && (date.includes('a. m.') || date.includes('p. m.'))) {
        const datePart = date.split(' ')[0]
        const parsedDate = moment(datePart, 'DD/MM/YYYY', true)
        return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : '-'
      }

      const parsedDate = moment(date)
      return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : '-'
    },

    openRegistrarConvocatoriaDialog() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRAR_CONVOCATORIA)
    },

    openEditarConvocatoriaDialog(convocatoria) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.EDITAR_CONVOCATORIA,
        props: {
          convocatoriaData: convocatoria,
        },
      })
    },

    openPersonalVinculadoDialog(convocatoria) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.PERSONAL_VINCULADO_CONVOCATORIA,
        props: {
          convocatoriaData: convocatoria,
        },
      })
    },

    openAsignarPersonalDialog(convocatoria) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.ASIGNAR_PERSONAL_MANUALMENTE_CONVOCATORIA,
        props: {
          convocatoriaData: convocatoria,
        },
        listeners: {
          'personal-added': async () => {
            await this.loadConvocatorias()
          },
        },
      })
    },

    downloadConvocatoriasCsv() {
      const rows = (this.filteredConvocatorias || []).map((item) => ({
        Convocatoria: item.convocatoria || '',
        'Plazas Vacantes': item.plazasVacantes || '',
        'Fecha Publicación': this.formatDate(item.fechaHoraPublicacionConvocatoria),
        'Fecha Inicio Registro': this.formatDate(item.fechaHoraInicioRegistro),
        'Fecha Cierre Registro': this.formatDate(item.fechaHoraCierreRegistro),
        'Fecha Resultados': this.formatDate(item.fechaHoraResultados),
        'Fecha Recepción Documentos': this.formatDate(item.fechaHoraRecepcionDocumentos),
        SubTipo: item.catSubTipoConvocatoria?.title || '',
        Tipo: item.catSubTipoConvocatoria?.catTipoConvocatoria?.title || '',
        'Dirigido a': item.catDirigido?.title || '',
        'Grado a Promocionar': item.catGradoPromocion?.title || '',
        Beneficios: item.beneficios || '',
        Requisitos: item.requisitos || '',
        Documentación: item.documentacion || '',
        'Lugar Recepción': item.lugarRecepcionDocumentos || '',
        'Procedimiento Selección': item.procedimientoSeleccion || '',
      }))

      downloadCsv(rows, { filename: 'convocatorias' })
    },
  },
}
</script>
